import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    serviceId: null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload.user;
    },
    setServiceId(state, payload) {
      state.serviceId = payload.serviceId
    }
  },
  actions: {
    async verifyAccount() {
      try {
        const res = await axios.get("https://auth.tactint.com/id/v3b4");
        this.commit("setUser", { user: res.data.data });
      } catch (e) {
        this.commit("setUser", { user: null });
        console.log(e);
        return e.response;
      }
    }
  }
});
